import React from 'react';
import { useAuth } from '../../Common/Configurations/AuthContext';
import { FaFacebookF, FaInstagram, FaTwitter, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

const SocialIcon = ({ platform }) => <a href="#" className="footer-social-icon">{platform}</a>;

const TemplateFooter1 = ({ branding }) => {
  const { user } = useAuth();
   const logoUrl = user?.logo || 'https://via.placeholder.com/150x40?text=Your+Logo';
  // We define styles that are structural. Colors are handled by CSS variables.
  const styles = {
    footer: {
      // --- THIS IS THE FIX ---
      // We change '--secondary' to the specific '--footer-bg-color' variable.
      backgroundColor: 'var(--footer-bg-color, #2c3e50)',
      
      color: 'var(--footer-text-color, #ecf0f1)',
      padding: '4rem 2rem 2rem 2rem',
      fontFamily: 'Arial, sans-serif',
    },
    container: {
      display: 'flex',
      justifyContent: 'space-around',
      flexWrap: 'wrap',
      gap: '2rem',
      maxWidth: '1200px',
      margin: '0 auto',
      textAlign: 'left',
    },
    column: { flex: 1, minWidth: '200px' },
    title: {
      fontSize: '1.2rem',
      fontWeight: 'bold',
      marginBottom: '1rem',
      color: 'var(--footer-title-color, #ffffff)', // Variable for titles
    },
    link: {
      display: 'block',
      color: 'var(--footer-link-color, #bdc3c7)', // Variable for links
      textDecoration: 'none',
      marginBottom: '0.5rem',
    },
    bottomBar: {
      marginTop: '3rem',
      paddingTop: '1rem',
      borderTop: '1px solid rgba(255, 255, 255, 0.1)', // A subtle border
      textAlign: 'center',
      fontSize: '0.9rem',
      color: 'var(--footer-link-color, #bdc3c7)', // Reuse the link color
    },
  };

  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.column}>
          {/* We can get the brand name dynamically in the future */}
          <img src={logoUrl} alt="Company Logo" style={{ height: '100px' }} />
          <p>Your trusted partner in creating unforgettable travel memories.</p>
          <div className="d-flex gap-3">
                    <a href="#" style={styles.link}><FaFacebookF /></a>
                    <a href="#" style={styles.link}><FaInstagram /></a>
                    <a href="#" style={styles.link}><FaTwitter /></a>
                  </div>
        </div>
        <div style={styles.column}>
          <h3 style={styles.title}>Quick Links</h3>
          <a href="#" style={styles.link}>About Us</a>
          <a href="#" style={styles.link}>Destinations</a>
          <a href="#" style={styles.link}>Packages</a>
          <a href="#" style={styles.link}>Contact</a>
        </div>
        <div style={styles.column}>
          <h3 style={styles.title}>Support</h3>
          <a href="#" style={styles.link}>FAQ</a>
          <a href="#" style={styles.link}>Terms of Service</a>
          <a href="#" style={styles.link}>Privacy Policy</a>
        </div>
        <div style={styles.column}>
          <h3 style={styles.title}>Newsletter</h3>
          <p>Get the latest deals and travel tips.</p>
          <input type="email" placeholder="Your Email" className="form-control mb-2" />
          {/* This button will be automatically styled by the theme's primary color */}
          <button className="btn btn-primary w-100">Subscribe</button>
        </div>
      </div>
      <div style={styles.bottomBar}>
        &copy; {new Date().getFullYear()} {user?.brandName || 'Zotrai'}. All Rights Reserved.
      </div>
    </footer>
  );
};

export default TemplateFooter1;